import { render, staticRenderFns } from "./LoanableSidebar.vue?vue&type=template&id=9fc909f2&scoped=true"
import script from "./LoanableSidebar.vue?vue&type=script&lang=js"
export * from "./LoanableSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc909f2",
  null
  
)

export default component.exports